module.exports = __webpack_public_path__ + "img/ruai-2.17edf5ec.png";